import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading'
import Input from './../form/inputs/Input'
import Radio from './../form/radio/Radio'
import RadioRangeSlider from './../form/radio-range-slider/RadioRangeSlider';
import LineSeperator from '../line-seperator/LineSeperator';
import Button from '../buttons/Button';
import ChooseContract from '../choose-contract/ChooseContract';
import { convertPrice } from './../../services/convertPrice';
import { getMinimumMonths } from './../../services/getMinimumMonths';
import ModalAxa from '../static-modals/ModalAxa'
import ModalWhyGrenke from '../static-modals/ModalWhyGrenke'
import DownloadIcon from './../../images/download-icon.svg';
import TypeOfContractLine from './../../images/type-of-contract-line.svg';


const TypeOfContract = ( props ) => {
    let [ showPopupAxa, setShowPopupAxa ] = useState(false);
    let [ showPopupWhy, setShowPopupWhy ] = useState(false);
    let [ radioClickedLeasingTimeChange, setRadioClickedLeasingTimeChange ] = useState(0);
    let [ radioClickedInitialChargeChange, setRadioClickedInitialChargeChange ] = useState(0);

    //redux
    const dispatch = useDispatch()
    let leasingTime     = useSelector(state => state.leasingTime)
    let products        = useSelector(state => state.products)
    let initialCharge   = useSelector(state => state.initialCharge)
    let minInitial      = useSelector(state => state.minInitial)
    let maxInitial      = useSelector(state => state.maxInitial)
    let productPrice    = useSelector(state => state.productPrice)
    let tax             = useSelector(state => state.tax)
    let productPriceEnd = useSelector(state => state.productPriceEnd)
    let activeContract  = useSelector(state => state.selectedLease)
    let modernLease     = useSelector(state => state.modernLease)
    let traditionalLease= useSelector(state => state.traditionalLease)
    let minMonth        = useSelector(state => state.minMonth)
    let maxMonth        = useSelector(state => state.maxMonth)
    let repurchase      = useSelector(state => state.repurchase)
    let isShop          = useSelector(state => state.isShop)
    let showTax         = useSelector(state => state.showTax)
    let fvFile          = useSelector(state => state.fvFile)
    let fromDbLoaded    = useSelector(state => state.fromDbLoaded)


    useEffect(() => {
        if ( typeof(minMonth) == 'string' ) {
            dispatch({ type: 'LEASING_TIME_CHANGE', value: minMonth })
        }
    }, [minMonth]);

    useEffect(() => {
        if ( activeContract != 'nowoczesny') {
            let min = getMinimumMonths(products)
            dispatch({ type: 'MIN_MONTH_CHANGE', value: min});
        } else {
            dispatch({ type: 'LEASING_TIME_CHANGE', value: leasingTime })
        }
        
    }, [activeContract]);

    

    let setActiveMonth = () => {
        if ( minMonth.length > 0 ) {
            let months = getAllAvailableMonths()
            let searchDisabled = months.indexOf(minMonth);
            return months[searchDisabled].toString(); 
        }
    }
    
    let getAllAvailableMonths = () => {
        let allMonths = [ "12", "15", "24", "36", "48" ];
        let minMonthTemp =  window.AppConfig && window.AppConfig.minMonths ? window.AppConfig.minMonths : "12";
        
        let tempData = []
        allMonths.map( el => {
            if ( parseInt(el) >= parseInt(minMonthTemp) ) {
                tempData.push( el )
            }
        })

        if ( activeContract == 'nowoczesny') {
            dispatch({ type: 'MIN_MONTH_CHANGE', value: minMonthTemp});
            return allMonths
        } else {
            return tempData;

        }
        
    }

    let scrollToBox = () => {
        if ( window.innerWidth < 1025 ) {
            let elements = document.querySelectorAll('.shadow-box');
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement - 100
            });
            return false;
        } else {
            return false;
        }
        
    }

    let fvError = async() => {
        await dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  true } )
        let elements = document.querySelectorAll('.error');
        if( elements.length > 0 ) {
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement - 140
              });

              return true;
        } else {
            return false;
        }
    }

    let updateInput = ( type, value) => {
        if ( fvFile.length === 0 && value.length > 0 && !fromDbLoaded ) {
            fvError();
        }
        dispatch( {type: type, value: value } )
    }

    return (
        <div className={ "type-of-contract " + (isShop ? 'shop' : '') }>
            <Heading title="Classical lease" 
                    borderBottom 
                    tip={ false } 
                    tipHeader="Classical lease"
                    tipText="Wskaż pełną nazwę firmy wybranego Dostawcy oraz kod pocztowy wskazany na fakturze proforma/zamówieniu." />

            <Heading title="Chose the period" 
                    medium />

            {/* <Radio data={ getAllAvailableMonths() }
                   setFunction={ (val) => {  updateInput('LEASING_TIME_CHANGE', val ); setRadioClickedLeasingTimeChange(1); radioClickedInitialChargeChange == 1 && scrollToBox() }}
                   minimum={ minMonth }
                   maximum= { maxMonth }
                   class="time"
                   active={ leasingTime ? leasingTime : setActiveMonth() }
                   gtmClass="leasing-period-radio" /> */}
            <RadioRangeSlider data={ getAllAvailableMonths() }
                   setFunction={ (val) => {  updateInput('LEASING_TIME_CHANGE', val ); setRadioClickedLeasingTimeChange(1); radioClickedInitialChargeChange == 1 && scrollToBox() }}
                   minimum={ minMonth }
                   maximum= { maxMonth }
                   class="time"
                   active={ leasingTime ? leasingTime : setActiveMonth() }
                   gtmClass="leasing-period-radio" />
            <div className="download-links desktop">
                <a className="link" href={`${window.location.origin}/7_UAE Insurance Conditions.pdf`} target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div>
                    Insurance conditions
                </a>
                <a className="link" onClick={ () => setShowPopupWhy(true) }target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div> 
                    Benefits of Grenke rental
                </a>
                <a className="link" href="https://www.grenke.ae/gtc/" target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div>
                    Terms and Conditions
                </a>
            </div>
            <div className="row line-graphic">
                <img src={TypeOfContractLine} alt="" />
            </div>
            {/* <div className="links">
                <a onClick={ () => setShowPopupAxa(true) }><span>//</span> Zakres i koszty Ramowego Ubezpieczenia Majątkowego</a>
                <a onClick={ () => setShowPopupWhy(true) }><span>//</span> Korzyści finansowania GRENKE</a>
                {isShop && products && products.length == 1 &&
                    <div className="oneItemBlue">Aby skalkulować w leasingu więcej niż 1 przedmiot dodaj je do koszyka a następnie uruchom kalkulator.</div>
                }
            </div> */}
            {/* { showPopupAxa &&
                <ModalAxa closeModal={ () => setShowPopupAxa(false) } data={ window.AppConfig ? window.AppConfig.modalAxaText : null } />
            } */}
            { showPopupWhy &&
                <ModalWhyGrenke closeModal={ () => setShowPopupWhy(false) } />
            }
        </div>
    )
}

export default TypeOfContract;